export const convertUnicode = (input) => {
    return input.replace(/\\u(\w\w\w\w)/g,(a,b) => {
        let charcode = parseInt(b,16);
        return String.fromCharCode(charcode);
    });
};
